// extracted by mini-css-extract-plugin
export default {"root":"accept_root__B4In1"};